import LinkRegular from '@/components/atoms/LinkRegular'
import CrossIcon from 'public/images/cross.svg'
import routes from '@/config/routes'

import ComponentStyled from './styled'

type Props = {
  prepend?: string
  title?: string
  description?: string
}

const ModalHeader = ({ prepend, title, description }: Props): JSX.Element => {
  return (
    <ComponentStyled>
      <LinkRegular href={routes.wishes}>
        <CrossIcon className='close' />
      </LinkRegular>
      {prepend && <p className='modal-header-title'>{prepend}</p>}
      {title && <p className='modal-title'>{title}</p>}
      {description && <p className='modal-description'>{description}</p>}
    </ComponentStyled>
  )
}

export default ModalHeader
